var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.9976,
    r: 25,
    fill: "#024BD5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578:1675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1206 16.6347L34.3624 14.8765C33.7764 14.2905 33.0086 13.9976 32.2408 13.9976C31.473 13.9976 30.7052 14.2905 30.1197 14.876L26.628 18.3677L24.9991 19.9966L13.6014 31.3938L13.0061 36.7479C12.9311 37.4219 13.4622 37.9976 14.1217 37.9976C14.1634 37.9976 14.2056 37.9952 14.2478 37.9905L19.5981 37.3994L31 25.9976L32.6284 24.3691L36.1202 20.8774C37.292 19.7055 37.292 17.8062 36.1206 16.6347ZM18.5655 35.2502L15.3977 35.5999L15.7506 32.4269L26.59 21.5876L28.0441 20.1335L30.8631 22.9526L29.4091 24.4066L18.5655 35.2502ZM34.5292 19.286L32.4536 21.3616L29.635 18.5426L31.7106 16.4669C31.9019 16.2757 32.125 16.2471 32.2408 16.2471C32.3566 16.2471 32.5802 16.2757 32.7709 16.4669L34.5292 18.2252C34.8217 18.5182 34.8217 18.994 34.5292 19.286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578:1675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13.9976)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.350278f4.svg";
export { ForwardRef as ReactComponent };